/**
 * Project: Academy V2
 * File: FeedbackItem.tsx
 * Author: Colopi Salvatore
 * Author URI: https://salvatorecolopi.com
 * Created: Wed Jul 10 2024 at 19:09:19
 *
 * Copyright (c) 2024 Edusogno. All rights reserved.
 */

import routes from "@/config/routes.ts";
import { ClassReportsItem, NavigationState } from "@/types";
import { cn } from "@edusogno/lib/utils";
import Button from "@edusogno/primitives/button";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import EyeIcon from "../icons/EyeIcon";
// import NewNotificationIcon from "../icons/NewNotificationIcon";

interface FeedbackProps {
  report: ClassReportsItem;
}

export default function ClassReportFeedback({ report }: FeedbackProps) {
  const { tutor, event } = report;
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`${routes.class_report}/${report.user_id}/${event.id}`, {
      state: {
        isCR: true,
        linkVideo: event.link_video,
        typeCR: event.type,
        tutorPic: tutor?.profile_pic,
        tutorName: tutor?.first_name,
        tutorSurname: tutor?.last_name,
      } as NavigationState,
    });
  };

  return (
    <>
      <div
        className={
          "flex flex-row lg:gap-5 px-4 py-2 lg:px-6 lg:py-4 justify-between rounded-md items-center center w-full bg-white"
        }
      >
        <div className={"flex-row flex items-center gap-5 w-[95%]"}>
          <div className="relative">
            {/* {isNew && ( */}
            {/* <NewNotificationIcon
              className={"absolute w-[6px] h-[6px] -top-[2px] -left-[6px]"}
            /> */}
            {/* )} */}
            <div className={"flex flex-col lg:gap-2 items-start justify-start"}>
              <div
                className={cn(
                  " rounded-md  lg:text-14px px-2 py-0.5 font-semibold flex justify-center items-center",
                  {
                    "bg-[--primary100] text-[--secondary]":
                      event.type?.toLowerCase() === "speaking",
                    "bg-[--green100] text-[--secondary] ":
                      event.type?.toLowerCase() === "ielts",
                    "bg-brand-lavender text-[--primary] ":
                      event.type?.toLowerCase() === "grammar",
                    " bg-[#6941C6] text-white ":
                      event.type?.toLowerCase() == "one to one",
                  },
                )}
              >
                {event.type}
              </div>
            </div>
          </div>
          <div className={"flex-col flex"}>
            <p className={"text-[--primary] text-xs"}>
              {t("materials.lesson_of")}{" "}
              <b className={"font-semibold uppercase"}>
                {dayjs(event?.data)
                  .format("ddd DD/MM/YYYY")
                  .toUpperCase()
                  .split(".")
                  .join(" ")}
                ,&nbsp;{event?.ora}
              </b>
            </p>
            <p
              className={
                "text-[--secondary] font-semibold text-base line-clamp-1"
              }
            >
              {event.titolo_argomento}
            </p>
          </div>
        </div>
        <Button
          onClick={handleClick}
          variant={"ghost"}
          className={"w-fit lg:hidden"}
        >
          <EyeIcon
            className={cn(
              "h-auto w-5 fill-[--primary] md:fill-current xl:hidden",
            )}
          />
        </Button>
        <Button
          onClick={handleClick}
          className={"hidden lg:block"}
          size={"sm"}
          color={"primary"}
        >
          {t("btns.view")}
        </Button>
      </div>
    </>
  );
}
